import React, { useState } from "react";
import { API_BASE_URL } from "./constants/adminConstants";
import "./css/adminStyles.css";

function AdminStaffSubmitChange() {
  const [description, setDescription] = useState("");
  const [changes, setChanges] = useState([{ field: "", oldValue: "", newValue: "" }]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddChange = () => {
    setChanges([...changes, { field: "", oldValue: "", newValue: "" }]);
  };

  const handleRemoveChange = (index) => {
    setChanges(changes.filter((_, i) => i !== index));
  };

  const handleChange = (index, key, value) => {
    const updated = [...changes];
    updated[index][key] = value;
    setChanges(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!description.trim()) {
      setMessage("Please enter a description.");
      return;
    }

    const validChanges = changes.filter((c) => c.field && c.newValue);
    if (validChanges.length === 0) {
      setMessage("Please add at least one change with a field and new value.");
      return;
    }

    setLoading(true);
    const token = sessionStorage.getItem("tvc_token");

    try {
      const res = await fetch(`${API_BASE_URL}/staff/submit-change`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ description, changes: validChanges }),
      });
      let data;
      try { data = await res.json(); } catch { data = {}; }

      if (res.ok) {
        setMessage("Change request submitted successfully!");
        setDescription("");
        setChanges([{ field: "", oldValue: "", newValue: "" }]);
      } else {
        setMessage(data.error || `Failed to submit change. (Status: ${res.status})`);
      }
    } catch (err) {
      setMessage(`Server error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="AdminCard">
      <h3 className="AdminCardHeader">Submit Change Request</h3>

      {message && (
        <p className={message.includes("success") ? "AdminSuccess" : "AdminError"}>{message}</p>
      )}

      <form onSubmit={handleSubmit}>
        <div className="AdminFormGroup">
          <label className="AdminLabel">Description</label>
          <textarea
            className="AdminTextarea"
            placeholder="Describe what change you want to make..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        <div className="AdminFormGroup">
          <label className="AdminLabel">Changes</label>
          {changes.map((change, index) => (
            <div key={index} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "center" }}>
              <input
                className="AdminInput"
                style={{ flex: 1 }}
                placeholder="Field name"
                value={change.field}
                onChange={(e) => handleChange(index, "field", e.target.value)}
              />
              <input
                className="AdminInput"
                style={{ flex: 1 }}
                placeholder="Old value (optional)"
                value={change.oldValue}
                onChange={(e) => handleChange(index, "oldValue", e.target.value)}
              />
              <input
                className="AdminInput"
                style={{ flex: 1 }}
                placeholder="New value"
                value={change.newValue}
                onChange={(e) => handleChange(index, "newValue", e.target.value)}
              />
              {changes.length > 1 && (
                <button
                  type="button"
                  className="AdminButton AdminButtonSmall AdminButtonDanger"
                  onClick={() => handleRemoveChange(index)}
                  style={{ width: "auto", padding: "8px 12px" }}
                >
                  X
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            className="AdminButton AdminButtonSmall AdminButtonSecondary"
            onClick={handleAddChange}
            style={{ marginTop: 4 }}
          >
            + Add Change
          </button>
        </div>

        <button className="AdminButton" type="submit" disabled={loading} style={{ marginTop: 16, width: "fit-content", padding: "8px 24px", display: "block", marginLeft: "auto", marginRight: "auto" }}>
          {loading ? "Submitting..." : "Submit Change Request"}
        </button>
      </form>
    </div>
  );
}

export default AdminStaffSubmitChange;
